import React from 'react';
import PropTypes from 'prop-types';
import { Input } from '../style';
export var Checkbox = function Checkbox(props) {
  return React.createElement(Input, {
    color: props.color,
    checked: props.checked
  });
};
Checkbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  color: PropTypes.string
};